import React from 'react'
import { Input } from '../../..'
import { DateUtils } from '../../../../utils'
import { GreenDot, RedDot } from '../../Estate/Store/StatusDot/StatusDot.styles'
import { colors } from '../../../../constants'
import ActionLink from '../../Estate/Store/ActionLink'
import { Icon } from '../../../Button/Button.style'
import { ActionGroup } from '../../ActionLogs/ActionLogs.styles'

const tableDisplay = ({ onDeleteLayer, bulkSelectionLayers, openCloseModal, selectedAll, bulkSelectionAllLayers, t }) => [
    {
        field: null,
        label: null,
        key: null,
        props: { align: 'left' },
        // eslint-disable-next-line react/prop-types
        transform: ({ selected, id }) => (
            <Input type="check" value={selected} onChange={(e) => bulkSelectionLayers(e, id)} borderColor={colors.bluedarkest} isInRow>
                View
            </Input>
        ),
        header: (
            <Input type="check" value={selectedAll} onChange={(e) => bulkSelectionAllLayers(e)} borderColor={colors.bluedarkest} isInRow>
                {t('View')}
            </Input>
        ),
        selectable: 'mandatory',
        width: '50px',
    },
    {
        field: 'id',
        label: 'ID',
        props: null,
        transform: null,
        width: '50px',
    },
    {
        field: 'name',
        label: 'Name',
        props: null,
        transform: null,
        width: '300px',
    },
    {
        field: 'offline',
        label: 'offline',
        props: null,
        transform: (offline) => (offline ? <RedDot /> : <GreenDot />),
        width: '30px',
    },
    {
        field: 'file_size',
        label: 'Size',
        props: { align: 'center' },
        transform: (fs) => `${Math.round((fs / 1024) * 100) / 100} KB`,
        width: '150px',
    },
    {
        field: 'date_start',
        label: 'Starting on',
        props: { align: 'center' },
        transform: (date) => (date ? DateUtils.formatUIShort(date) : 'n/a'),
        width: '150px',
    },
    {
        field: 'date_end',
        label: 'Ending on',
        props: { align: 'center' },
        transform: (date) => (date ? DateUtils.formatUIShort(date) : 'n/a'),
        width: '150px',
    },
    {
        field: 'id',
        key: 'actions',
        label: '',
        props: { align: 'right' },
        transform: (id) => (
            <ActionGroup>
                <ActionLink
                    onClick={(e) => {
                        e.preventDefault()
                        onDeleteLayer(id)
                    }}
                    confirmation={`${t('DeleteDeviceConfirmation')} ${id}`}
                    openConfirmation={openCloseModal}
                    confirmationContent={`${t('DeleteDeviceConfirmBody')} "${id}"?`}
                    confirmationHeader={t('Delete layer')}
                >
                    <Icon icon="trash-alt" title={t('Delete layer')} color={colors.red} />
                </ActionLink>
                {/* <ActionLink
                    onClick={(e) => {
                        e.preventDefault()
                        onClickUrl(id)
                    }}
                    confirmation={`${t('DeleteDeviceConfirmation')} ${id}`}
                    openConfirmation={openCloseModal}
                    confirmationContent={`${t('DeleteDeviceConfirmBody')} "${id}"?`}
                    confirmationHeader={t('Delete device')}
                >
                    <Icon icon="pencil-alt" title={t('Delete device')} />
                </ActionLink> */}
            </ActionGroup>
        ),
        width: null,
    },
]

export default tableDisplay
